import { render, staticRenderFns } from "./WhatsappComposer.vue?vue&type=template&id=1c67cdfa&"
import script from "./WhatsappComposer.vue?vue&type=script&lang=ts&"
export * from "./WhatsappComposer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports